import { ReactElement, useEffect, useRef } from 'react';
import Plotly from 'plotly.js-dist-min';
import type { Data, Layout, Config } from 'plotly.js';

interface Props {
  data: Data[];
  layout: Partial<Layout>;
  config?: Partial<Config>;
  height?: number;
}

export default function PlotlyChart({ data, layout, config, height = 500 }: Props): ReactElement {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    Plotly.react(node, data, layout, config ?? { responsive: true });
    return () => {
      Plotly.purge(node);
    };
  }, [data, layout, config]);

  return <div ref={ref} style={{ width: '100%', height }} />;
}
